<template>
  <div class="login-container d-flex justify-content-center align-items-center">
    <b-card class="login-card">
      <div class="d-flex flex-column align-items-center">
        <img class="login-logo" src="../assets/images/logo-word.png" alt="منصة البارون">
        <h3 class="text-center mb-4">أكاديمية البارون التعليمية</h3>
      </div>

      <b-tabs v-model="tabIndex" class="Logintab" content-class="mt-5">
        <b-tab title="تسجيل الدخول" active>

          <b-row>
            <b-col lg="6" md="12" sm="12">
              <!-- Fixed-height slot: the alert appears here without pushing the form down. -->
              <div class="alert-slot" aria-live="assertive">
                <b-alert :show="alertCountdown" dismissible fade :variant="alertType" class="mb-0"
                  @dismiss-count-down="countDownChanged">
                  {{ alertText }}
                </b-alert>
              </div>
              <b-form @submit.prevent="submitForm">
                <b-form-group id="group-username" label-for="admin-edit-username" label="رقم المحمول أو البريد الإلكتروني">
                  <b-form-input type="text" inputmode="email" autocomplete="username" dir="ltr" id="admin-edit-username"
                    name="admin-edit-username" v-model.trim="$v.form.username.$model"
                    :state="validateState('username')"></b-form-input>
                  <b-form-invalid-feedback id="input-edit-username">
                    {{ "رقم المحمول أو البريد الإلكتروني مطلوب" }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="group-password" label-for="admin-edit-password" label="كلمة المرور">
                  <b-form-input type="password" autocomplete="current-password" id="admin-edit-password" name="admin-edit-password" v-model="$v.form.password.$model"
                    :state="validateState('password')"></b-form-input>
                  <b-form-invalid-feedback id="input-edit-password">
                    {{ "كلمة المرور مطلوبه" }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group>
                  <b-link href="#" class="text-brand" @click.prevent="openForgotPassword">هل نسيت كلمة السر؟</b-link>
                </b-form-group>

                <b-button aria-label="تسجيل الدخول" :disabled="isLoading" type="submit" variant="brand" block>
                  <span class="text-center text-white my-2" :class="{ 'alert-div-padding': isLoading }"
                    v-show="isLoading">
                    جاري تسجيل الدخول <b-spinner class="align-middle mx-2"></b-spinner>
                  </span>
                  <span v-show="!isLoading">
                    تسجيل الدخول
                  </span>
                </b-button>
              </b-form>
            </b-col>
            <b-col lg="6" md="12" sm="12">
              <img style="width: 100%; height: 250px; object-fit: contain;" src="../assets/images/login_img.png"
                alt="تسجيل الدخول">
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="حساب جديد">
          <Signup @goToLogin="goToLogin"/>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-modal id="forgot-password-modal" v-model="forgotPassword.show" title="استعادة كلمة المرور" centered hide-footer
      @hidden="resetForgotPassword">
      <b-alert :show="!!forgotPassword.alertText" :variant="forgotPassword.alertType">
        {{ forgotPassword.alertText }}
      </b-alert>
      <b-form v-if="!forgotPassword.sent" @submit.prevent="submitForgotPassword">
        <b-form-group label="البريد الإلكتروني" label-for="forgot-password-email"
          description="أدخل البريد الإلكتروني المسجل وسنرسل لك رابط إعادة تعيين كلمة المرور">
          <b-form-input id="forgot-password-email" type="email" autocomplete="email" required
            v-model.trim="forgotPassword.email"></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="brand" block :disabled="forgotPassword.isLoading">
          <span v-if="forgotPassword.isLoading">جاري الإرسال <b-spinner small class="mx-2"></b-spinner></span>
          <span v-else>إرسال رابط إعادة التعيين</span>
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Signup from '../components/auth/Signup.vue';
import { validationMixin } from "vuelidate";
import { sendRequest } from "../utils/RequestHelper.js"
import jwt_decode from "jwt-decode";
import store from "../store/index.js"

import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  data() {
    return {
      alertCountdown: 0,
      alertType: '',
      alertText: '',
      form: {
        username: '',
        password: ''
      },
      isLoading: false,
      tabIndex: 0,
      forgotPassword: {
        show: false,
        email: '',
        isLoading: false,
        sent: false,
        alertType: '',
        alertText: ''
      }
    };
  },
  // validations
  validations: {
    form: {
      username: {
        required
      },
      password: {
        required
      },
    },
  },
  components: {
    Signup
  },
  methods: {
    goToLogin() {
      setTimeout(() => { this.tabIndex = 0 }, 3000);
    },
    countDownChanged(alertCountdown) {
      this.alertCountdown = alertCountdown
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    loginErrorMessage(apiError) {
      if (apiError.code === "network_error") {
        return "تعذر الاتصال بالخادم. تأكد من اتصالك بالإنترنت وحاول مرة أخرى";
      }
      if (apiError.status === 429) {
        return "لقد تجاوزت عدد المحاولات المسموح بها. من فضلك حاول مرة أخرى بعد قليل";
      }
      // The API distinguishes a wrong password from an account that was never
      // activated; showing one message for both leaves new users stuck.
      if (apiError.code === "account_inactive") {
        return "لم يتم تفعيل حسابك بعد. من فضلك افتح رابط التفعيل المرسل إلى بريدك الإلكتروني";
      }
      return "اسم المستخدم او كلمة المرور غير صحيحة";
    },
    openForgotPassword() {
      this.forgotPassword.show = true;
    },
    resetForgotPassword() {
      Object.assign(this.forgotPassword, {
        email: '', isLoading: false, sent: false, alertType: '', alertText: ''
      });
    },
    submitForgotPassword() {
      if (!this.forgotPassword.email) {
        return;
      }
      this.forgotPassword.isLoading = true;
      this.forgotPassword.alertText = '';
      var successCallback = () => {
        this.forgotPassword.isLoading = false;
        this.forgotPassword.sent = true;
        this.forgotPassword.alertType = "success";
        this.forgotPassword.alertText = "إذا كان هذا البريد مسجلاً لدينا، فسيصلك رابط إعادة تعيين كلمة المرور خلال دقائق";
      };
      var errorCallback = (apiError) => {
        this.forgotPassword.isLoading = false;
        this.forgotPassword.alertType = "danger";
        if (apiError.code === "network_error") {
          this.forgotPassword.alertText = "تعذر الاتصال بالخادم. تأكد من اتصالك بالإنترنت وحاول مرة أخرى";
        } else if (apiError.status === 429) {
          this.forgotPassword.alertText = "لقد تجاوزت عدد المحاولات المسموح بها. من فضلك حاول مرة أخرى بعد قليل";
        } else if (apiError.status === 400) {
          this.forgotPassword.alertText = "من فضلك أدخل بريداً إلكترونياً صحيحاً";
        } else {
          this.forgotPassword.alertText = "حدث خطأ ما. من فضلك حاول مرة أخرى";
        }
      };
      sendRequest('post', 'auth/request-password-reset/', false, { email: this.forgotPassword.email }, successCallback, errorCallback);
    },
    submitForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.login();
    },
    login() {
      this.isLoading = true;
      let data = Object.assign(this.form, {})
      var successCallback = (data) => {
        let access = data.access
        store.commit("SET_TOKEN", access);

        var decoded = jwt_decode(access);
        
        store.commit("SET_USERNAME", decoded.user.full_name);
        store.commit("SET_ACCOUNT_TYPE", 'student');
        store.commit("SET_USERID", decoded.user_id);
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        }
        else {
          this.$router.push({
            name: "landingPage"
          })
        }
      };
      var errorCallback = (apiError) => {
        this.isLoading = false;
        this.alertType = "danger"
        this.alertText = this.loginErrorMessage(apiError)
        this.alertCountdown = Number(process.env.VUE_APP_ALERT_COUNTDOWN) || 8;
      };
      sendRequest('post', 'auth/login/', false, data, successCallback, errorCallback, true);
    }

  },
  created() {
    if (store.getters.authToken) {
      this.$router.push({
        name: 'landingPage'
      })
    }
  }
};
</script>

<style scoped>
.login-container {
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  margin: 60px 0px;
  width: 70%;
  border-radius: 10px;
}

.login-logo {
  height: 110px;
  width: 110px;
  object-fit: contain;
  filter: drop-shadow(0 6px 14px rgba(11, 61, 56, 0.18));
}

.Logintab>>>.nav {
  display: flex;
  justify-content: center;
  width: 100%;
  border: unset;
}

.Logintab>>>.nav-tabs .nav-item .nav-link {
  padding: 10px 20px !important;
  color: gray !important;
  border-bottom: 3px solid gray !important;
  transition: all 0.3s ease-in-out;
}

.Logintab>>>.nav-tabs .nav-item .nav-link.active {
  color: var(--brand-teal) !important;
  border: unset;
  margin: 0px 0px;
  border-bottom: 3px solid var(--brand-teal) !important;
  font-weight: bold;
}

.Logintab>>>.nav-tabs .nav-item {
  margin: 0 15px !important;
}

.alert-slot {
  min-height: 72px;
  display: flex;
  align-items: center;
}

.alert-slot .alert {
  width: 100%;
}

.is-invalid {
  border: 2px solid red !important;
}

/* tablet */
@media (max-width: 800px) {
  .login-card {
    margin-top: 20px;
    width: 90%;
    padding: 0px;
  }

  .Logintab>>>.nav {
    display: flex;
    justify-content: center;
  }

  .Logintab>>>.nav a {
    font-size: 20px !important;
  }

  .Logintab>>>.nav-tabs .nav-item {
    margin: 0 5px !important;
  }

  .Logintab>>>.nav-tabs .nav-item .nav-link {
    padding: 5px 10px !important;
    border-bottom: 2px solid gray !important;
  }

  .Logintab>>>.nav-tabs .nav-item .nav-link.active {
    padding: 5px 10px !important;
    border-bottom: 2px solid var(--brand-teal) !important;
  }
}

/* small phones: keep both tabs on one row */
@media (max-width: 400px) {
  .login-card {
    width: calc(100% - 24px);
  }

  .Logintab>>>.nav a {
    font-size: 16px !important;
  }

  .Logintab>>>.nav-tabs .nav-item {
    margin: 0 2px !important;
  }
}
</style>
